import { Switcher } from '@components/Switcher';
import { memo, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FxRemittanceType } from 'types/operations';

import type { FXFormValues } from '../hooks/useFXFormState';

interface PaymentTypeSwitcherProps {
	disabled?: boolean;
}

export const PaymentTypeSwitcher = memo(({ disabled }: PaymentTypeSwitcherProps) => {
	const { control } = useFormContext<FXFormValues>();
	const { t } = useTranslation('', {
		keyPrefix: 'payments.newPayment.additionalData.fx.paymentTypes',
	});

	const options = useMemo(
		() => [
			{
				value: FxRemittanceType.LOCAL,
				label: t('local'),
			},
			{
				value: FxRemittanceType.SWIFT,
				label: t('swift'),
			},
		],
		[t],
	);

	return (
		<Controller
			control={control}
			name="fx_remittance_type"
			render={({ field: { value, ...field } }) => (
				<Switcher
					{...field}
					className="mt-space-16"
					disabled={disabled}
					options={options}
					value={value ?? ''}
				/>
			)}
		/>
	);
});

PaymentTypeSwitcher.displayName = 'PaymentTypeSwitcher';
